/**
 * CustomAgendaEvent - Event renderer for agenda view
 * Shows detailed appointment info with more space
 */
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CustomAgendaEvent = ({ event }) => {
  const { t } = useTranslation();
  
  return (
    <div className="py-1">
      <div className="font-medium text-white">{event.title}</div>
      {event.installerName && (
        <div className="text-sm text-white/90 flex items-center gap-1 mt-0.5">
          <User size={12} /> {t('appointment.assignedInstaller')}: {event.installerName}
        </div>
      )}
      {event.createdByName && (
        <div className="text-sm text-white/80 flex items-center gap-1 mt-0.5">
          <User size={12} /> {t('appointment.createdBy')}: {event.createdByName}
        </div>
      )}
      {event.resource?.scheduled_time && (
        <div className="text-sm text-white/90 font-medium">
          🕐 {event.resource.scheduled_time}
        </div>
      )}
    </div>
  );
};

export default CustomAgendaEvent;
